export default __webpack_public_path__ + "static/hero-background-c1ad179bdce5a02de2e9fa50067f6cfa.jpg";